import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import { toast } from "react-toastify";
import DeleteModal from "../../components/common/deleteModal";
import { getId, getName, getRole } from "../../utils/helpers/custom";
import {
  deleteLeave,
  filterOfLeaveDetails,
  countOfLeave,
} from "../../api/leaveApi";
import * as Yup from "yup";
import { useFormik } from "formik";
import BreadCrumb from "../../components/common/breadCrumb";
import Widgets from "../dashboard/widgets";
import {
  addLeave,
  approveRejectLeave,
  listOfLeave,
  viewLeave,
  viewLeaveOfEmployee,
} from "../../api/leaveApi";
import TableContainer from "../../components/common/tableContainer";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { RequiredField } from "../../utils/helpers/validationMasseges";
import {
  dateFormat,
  dateFormatChange,
  getInputPlaceholder,
  getSelectPlaceholder,
} from "../../utils/helpers/common";
import {
  LEAVE_CATEGORIES,
  LEAVE_STATUS_ENUM,
  LEAVE_TYPES,
  leaveCategoryOptions,
  leaveStatusOptions,
  leaveTypeOptions,
  ResponseStatusEnum,
} from "../../utils/helpers/enums";
import { countOfData, countOfDataCard } from "../../api/commonApi";
import Loader from "../../components/common/loader";
import FixedHeaderDatatables from "../../components/common/datatableCom";
import ApproveRejectModal from "../../components/common/approveRejectModal";
import NoResultsMessage from "../../components/noResultMessage";
import { leaveStatus } from "../../utils/helpers/enums";
import LeaveModal from "../../components/common/LeaveModal";
import {
  ADMIN,
  NAME,
  NUMBER_OF_DAYS,
  REASON,
  STATUS,
} from "../../common/constant/Leave";
import BaseInput from "../../base/baseInput";
import { BaseSelect } from "../../base/baseSelect";

const Status = ({ status }) => {
  switch (status) {
    case "Pending":
      return (
        <span className="badge badge-soft-warning text-uppercase">
          {status}
        </span>
      );
    case "Rejected":
      return (
        <span className="badge badge-soft-danger text-uppercase">{status}</span>
      );
    case "Approved":
      return (
        <span className="badge badge-soft-success text-uppercase">
          {status}
        </span>
      );
    default:
      return (
        <span className="badge badge-soft-success text-uppercase">
          {status}
        </span>
      );
  }
};

const HRLeaves = () => {
  document.title = "HR Leaves";
  const role = getRole();
  const name = getName();
  const id = getId();
  const [listLeave, setListLeave] = useState([]);
  const [datee, setDatee] = useState("");
  const [date1, setDate2] = useState("");
  const [leaveCardData, setLeaveCardDate] = useState();
  const [loading, setLoading] = useState(false);
  const [approveCardData, setApproveCardData] = useState();
  const [pedningCardData, setPendingCardData] = useState();
  const [leaveRejectData, setLeaveRejectData] = useState([]);
  const [leaveRejectNameData, setLeaveRejectNameData] = useState([]);
  const [countOfCardData, setCountOfCardData] = useState();
  const [isApproveRejectModalOpen, setApproveRejectModalOpen] = useState(false);
  const [response, setResponse] = useState(null);
  const [stateValue, setStateValue] = useState(false);
  const [isLeaveModalOpen, setIsLeaveModalOpen] = useState(false);
  const [countOfDataCards, setCountOfDataCards] = useState();
  const [editData, setEditData] = useState(null);
  const [tableLoader, setTableLoader] = useState(false);
  const handleEdit = (rowData) => {
    setEditData(rowData);
    setIsLeaveModalOpen(true);
  };

  const fetchData = () => {
    if (role === "Admin") {
      setLoading(true);
      listOfLeave()
        .then((response) => {
          setListLeave(response?.data?.data);
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(true);
      viewLeave(id)
        .then((response) => {
          setListLeave(response?.data?.data);
        })
        .catch((err) => err)
        .finally(() => {});
    }
    countOfData({
      modelName: "leaveModel",
      condition: {
        status: "Pending",
        userId: id,
      },
    })
      .then((response) => {
        setPendingCardData(response?.data?.data);
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {});
    countOfData({
      modelName: "leaveModel",
      condition: {
        status: "Approve",
        userId: id,
      },
    })
      .then((response) => {
        setApproveCardData(response?.data?.data);
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {});
    if (role === "Admin") {
      countOfData({
        modelName: "leaveModel",
      })
        .then((response) => {
          setLeaveCardDate(response?.data?.data);
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      countOfData({
        modelName: "leaveModel",
        condition: {
          userId: id,
        },
      })
        .then((response) => {
          setLeaveCardDate(response?.data?.data);
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {
          setLoading(false);
        });
      countOfLeave(id)
        .then((response) => {
          setCountOfCardData(response?.data?.data);
        })
        .catch((err) => {
          setLoading(false);
          return err;
        })
        .finally(() => {
          setLoading(false);
        });
      countOfDataCard(id)
        .then((response) => {
          setCountOfDataCards(response?.data?.data);
        })
        .catch((err) => {
          setLoading(false);
          return err;
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchData();
    setDatee("");
    setDate2("");
  }, []);
  const [deleteState, setDeleteState] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalProject, setModalProject] = useState(false);
  const deleteFunc = (data) => {
    setDeleteState(data);
    setDeleteModal(true);
  };

  const [selectedLeaveId, setSelectedLeaveId] = useState(null);

  const handleOpenApproveRejectModal = (leaveId) => {
    setSelectedLeaveId(leaveId);
    setApproveRejectModalOpen(true);
  };

  const handleCloseApproveRejectModal = () => {
    setApproveRejectModalOpen(false);
  };

  const handleDeleteLeave = (leaveId) => {
    setLoading(true);
    const payload = {
      id: leaveId,
      isDeleted: true,
    };
    setApproveRejectModalOpen(true);
    deleteLeave(payload)
      .then((response) => {
        if (response?.data?.statusCode === ResponseStatusEnum?.SUCCESS) {
          toast.success(response?.data?.message);
          handleCloseApproveRejectModal(false);
        }
        setResponse(response?.data);
        setTableLoader(true);
        filterOfLeaveDetails({
          userId: id,
        }).then((response) => setlistOfLeaveData(response?.data?.data))
          .finally((err) => {
          setTableLoader(false);
        })
      })
      .catch((err) => {
        toast.error(err?.data?.message);
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const leaveColumns = useMemo(() => [
    {
      Header: "Type Of Leave",
      accessor: "categoryLeave",
      filterable: false,
    },
    {
      Header: "From Date",
      accessor: "fromDate",
      filterable: false,
      Cell: (cell) => {
        const { fromDate } = cell.row.original;
        return fromDate !== null ? <div>{dateFormat(fromDate)}</div> : "-";
      },
    },
    {
      Header: "To Date",
      accessor: "toDate",
      filterable: false,
      Cell: (cell) => {
        const { toDate } = cell.row.original;
        return toDate !== null ? <div>{dateFormat(toDate)}</div> : "-";
      },
    },
    {
      Header: "Acquire Date",
      accessor: "acquireDate",
      filterable: false,
      Cell: (cell) => {
        const { acquireDate } = cell.row.original;
        return acquireDate !== null ? (
          <div>{dateFormat(acquireDate)}</div>
        ) : (
          "-"
        );
      },
    },
    {
      Header: "Leave Days",
      accessor: "numberOfDays",
      filterable: false,
    },
    {
      Header: "Leave Duration",
      accessor: "leaveType",
      filterable: false,
    },
    {
      Header: "Reason",
      accessor: "leaveReason",
      filterable: false,
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (item) => {
        if (role === "Admin") {
          return (
            <div>
              {item?.row?.original?.status === "Approve" ||
              item?.row?.original?.status === "Reject" ? (
                <Status status={item?.row?.original?.status} />
              ) : (
                <div className="hstack gap-2">
                  <button
                    id={`modalTodo-${item?.cell?.row?.index}`}
                    className="btn btn-sm btn-soft-info edit-list"
                    onClick={() => {
                      approveRejectLeave({
                        id: item?.cell?.row?.original?.id,
                        userId: item?.cell?.row?.original?.userId,
                        reason: "",
                        status: "Approve",
                      }).then((response) => {
                        if (
                          response?.data?.statusCode ===
                          ResponseStatusEnum.SUCCESS
                        ) {
                          toast.success(response?.data?.message);
                          listOfLeave().then((response) => {
                            setListLeave(response?.data?.data);
                          });
                        }
                      });
                    }}
                  >
                    <i className="ri-check-line align-bottom" />
                    <ReactTooltip
                      place="bottom"
                      variant="info"
                      content="Approve"
                      anchorId={`modalTodo-${item?.cell?.row?.index}`}
                    />
                  </button>
                  <button
                    id={`deleteTodo-${item?.cell?.row?.index}`}
                    className="btn btn-sm btn-soft-danger remove-list"
                    onClick={() => {
                      handleTodoClicksReject();
                      setLeaveRejectData(item?.cell?.row?.original);
                      setLeaveRejectNameData(item?.cell?.row?.original?.users);
                    }}
                  >
                    <i className="ri-close-line align-bottom" />
                    <ReactTooltip
                      place="bottom"
                      variant="error"
                      content="Reject"
                      anchorId={`deleteTodo-${item?.cell?.row?.index}`}
                    />
                  </button>
                </div>
              )}
            </div>
          );
        } else {
          return <Status status={item?.value} />;
        }
      },
    },
    {
      Header: "Action",
      Cell: (cell) => {
        const { status } = cell.row.original;
        const isPending = status === "Pending";

        return (
          <div className="hstack gap-2">
            {isPending && (
              <>
                <button
                  className="btn btn-sm btn-soft-danger remove-list"
                  data-tooltip-id={`delete-${cell.row.id}`}
                  onClick={() =>
                    handleOpenApproveRejectModal(cell?.row?.original?.id)
                  }
                >
                  <i className="ri-delete-bin-line" aria-hidden="true">
                    
                  </i>
                </button>
                <ReactTooltip
                  id={`delete-${cell.row.id}`}
                  content="Delete"
                  place="bottom"
                />
                <button
                  className="btn btn-sm btn-soft-primary"
                  onClick={() => handleEdit(cell.row.original)}
                  data-tooltip-id={`edit-${cell.row.id}`}
                >
                  <i className="ri-pencil-line align-bottom" />
                </button>
                <ReactTooltip
                  id={`edit-${cell.row.id}`}
                  content="Edit"
                  place="bottom"
                />
              </>
            )}
          </div>
        );
      },
    },
  ]);
  const [todo, setTodo] = useState(null);
  const [modalTodo, setModalTodo] = useState(false);
  const [modalTodoReject, setModalTodoReject] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditReject, setIsEditReject] = useState(false);
  const [listOfLeaveData, setlistOfLeaveData] = useState([]);

  const employeeLeave = [
    {
      id: 1,
      cardColor: "primary",
      label: "Annual Leave",
      badgeClass: "success",
      counter: 12,
      bgcolor: "success",
      icon: "ri-account-box-fill",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: 2,
      cardColor: "primary",
      label: "Balance Leave",
      badgeClass: "success",
      counter: countOfDataCards?.[0]?.remainingCasualLeave,
      bgcolor: "success",
      icon: "ri-team-fill",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: 3,
      cardColor: "primary",
      label: "Compoff",
      badgeClass: "success",
      counter: countOfDataCards?.[0]?.remainingCompOfLeave,
      bgcolor: "success",
      icon: "ri-file-list-3-fill",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: 4,
      cardColor: "primary",
      label: "LWP",
      badgeClass: "success",
      counter: countOfDataCards?.[0]?.totalLwpLeave,
      bgcolor: "success",
      icon: "ri-file-list-3-fill",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
  ];
  const toggle = useCallback(() => {
    if (modalTodo) {
      setModalTodo(false);
      setTodo(null);
    } else {
      setModalTodo(true);
    }
  }, [modalTodo]);

  const toggleReject = useCallback(() => {
    if (modalTodoReject) {
      setModalTodoReject(false);
    } else {
      setModalTodoReject(true);
    }
  }, [modalTodoReject]);

  const handleTodoClicksReject = () => {
    setModalTodoReject(!modalTodo);
    setIsEditReject(false);
    toggleReject();
  };

  const handleDeleteTodo = (data) => {
    if (todo) {
      setDeleteModal(false);
    }
    deleteLeave({ id: deleteState, isDeleted: true })
      .then((response) => {
        if (response?.data?.statusCode === ResponseStatusEnum.SUCCESS) {
          toast.success(response?.data?.message);
          setDeleteModal(false);
          viewLeave(id).then((response) => {
            setListLeave(response?.data?.data);
          });
        } else {
          toast.warning(response?.data?.message);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };

  const RegEx = /^[A-Za-z\s]*$/;
  // To do Task List validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      leaveType: todo?.leaveType || "",
      leaveDays: todo?.leaveDays || "",
      reason: todo?.reason || "",
      fromDate: todo?.fromDate || "",
      toDate: todo?.toDate || "",
    },
    validationSchema: Yup.object({
      leaveType: Yup.string().required(RequiredField("select leave")),
      leaveDays: Yup.string().required(RequiredField("number of days")),
      reason: Yup.string()
        .required(RequiredField("Reason"))
        .matches(RegEx, "Enter Only Characters"),
      fromDate: Yup.string().required(RequiredField("number of days")),
      toDate: Yup.string().required(RequiredField("number of days")),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        validation.resetForm();
      } else {
        setLoading(true);
        addLeave({
          userId: parseInt(id),
          fromDate: values.fromDate,
          toDate: values.toDate,
          leaveDays: values.leaveDays,
          reason: values.reason,
          status: "Pending",
          leaveType: values.leaveType,
        })
          .then((response) => {
            if (response?.data?.statusCode === ResponseStatusEnum.SUCCESS) {
              toast.success(response?.data?.message);
              viewLeave(id).then((response) => {
                setListLeave(response?.data?.data);
              });
            } else if (
              response?.data?.statusCode === ResponseStatusEnum.DUPLICATE
            ) {
              toast.warning(response?.data?.message);
            }
          })
          .catch((err) => err)
          .finally(() => {
            setLoading(false);
          });
        setDate2("");
        setDatee("");
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationReject = useFormik({
    enableReinitialize: true,

    initialValues: {
      reason: "",
    },
    validationSchema: Yup.object({
      reason: Yup.string().required("Please Enter Reason"),
    }),
    onSubmit: (values) => {
      approveRejectLeave({
        id: leaveRejectData.id,
        userId: leaveRejectData.userId,
        rejectReason: values.reason,
        status: "Reject",
      }).then((response) => {
        if (response?.data?.statusCode === ResponseStatusEnum.SUCCESS) {
          toast.success(response?.data?.message);
          listOfLeave().then((response) => {
            setListLeave(response?.data?.data);
          });
        }
      });
      validationReject.resetForm();
      toggleReject();
    },
  });

  useEffect(() => {
    setTableLoader(true);
    filterOfLeaveDetails({
      userId: id,
    })
      .then((response) => {
        setlistOfLeaveData(response?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setTableLoader(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    filterOfLeaveDetails({
      userId: id,
    })
      .then((response) => {
        setlistOfLeaveData(response?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
        setStateValue(false);
      });
  }, [stateValue]);

  const leaveFilterValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      categoryLeave: null,
      status: null,
      startDate: null,
      endDate: null,
    },
    onSubmit: (values) => {
      setTableLoader(true);
      const payload = {
        userId: id,
        categoryLeave: values?.categoryLeave,
        status: values?.status,
      };
      if (values.startDate) payload.startDate = values.startDate;
      if (values.endDate) payload.endDate = values.endDate;

      filterOfLeaveDetails(payload)
        .then((response) => setlistOfLeaveData(response?.data?.data))
        .catch((err) => {
          return err;
        })
        .finally(() => {
          setTableLoader(false);
        });
    },
  });

  const downloadTableData = () => {
    const main = document.getElementById("your-leavesId");
    const management = document.getElementById("leave-management");
    const filterId = document.getElementById("filteredId");
    const button = document.getElementById("leave-button");
    const paginationId = document.getElementById("paginationId");

    main.classList.add("nonPrintable");
    management.classList.add("nonPrintable");
    filterId.classList.add("nonPrintable");
    button.classList.add("nonPrintable");
    paginationId.classList.add("nonPrintable");
    window.print();

    main.classList.remove("nonPrintable");
    management.classList.remove("nonPrintable");
    filterId.classList.remove("nonPrintable");
    button.classList.remove("nonPrintable");
    paginationId.classList.remove("nonPrintable");
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
      />
      <ApproveRejectModal
        show={isApproveRejectModalOpen}
        onCloseClick={handleCloseApproveRejectModal}
        onDeleteClick={() => handleDeleteLeave(selectedLeaveId)}
        action="cancel leave"
      />
      <div className="page-content">
          <Container fluid id="main">
            <BreadCrumb title="Leaves" pageTitle="HRMS" />
            <div className="container-fluid">
              <Row className="mb-4 d-flex justify-content-between align-items-center">
                <Col lg={6} className="text-start">
                  <h5 className="fw-semibold mb-0">Leave Management</h5>
                </Col>
                <Col lg={6} className="text-end">
                  <button
                    className="btn btn-primary"
                    onClick={() => setIsLeaveModalOpen(true)}
                  >
                    Apply Leave
                  </button>
                </Col>
              </Row>
            </div>
            <Row id="your-leavesId">
              <Col lg={3}>
                <Widgets data={[employeeLeave[0]]} />
              </Col>
              <Col lg={3}>
                <Widgets data={[employeeLeave[1]]} />
              </Col>
              <Col lg={3}>
                <Widgets data={[employeeLeave[2]]} />
              </Col>
              <Col lg={3}>
                <Widgets data={[employeeLeave[3]]} />
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <Row className="w-100">
                  <Card id="leaveDetails">
                    <CardHeader>
                      <h5 className="card-title mb-0">Leave Details</h5>
                    </CardHeader>
                    <CardBody className="mt-4">
                      <div className="p-3 bg-light rounded mb-4">
                        <Form onSubmit={leaveFilterValidation.handleSubmit}>
                          <Row className="g-2" id="filteredId">
                            <Col>
                              <BaseSelect
                                label={""}
                                name="categoryLeave"
                                options={leaveCategoryOptions}
                                handleChange={(selectedOption) => {
                                  leaveFilterValidation.setFieldValue(
                                    "categoryLeave",
                                    selectedOption?.value
                                  );
                                }}
                                handleBlur={leaveFilterValidation.handleBlur}
                                value={leaveCategoryOptions.find(
                                  (opt) =>
                                    opt.value ===
                                    leaveFilterValidation.values.categoryLeave
                                )}
                                touched={
                                  leaveFilterValidation.touched.categoryLeave
                                }
                                error={
                                  leaveFilterValidation.errors.categoryLeave
                                }
                              />
                              {leaveFilterValidation?.errors?.categoryLeave &&
                              leaveFilterValidation?.values?.categoryLeave ? (
                                <div className="invalid-feedback">
                                  {leaveFilterValidation?.errors?.categoryLeave}
                                </div>
                              ) : null}
                            </Col>
                            <Col>
                              <BaseSelect
                                name="status"
                                className="mb-3"
                                options={LEAVE_STATUS_ENUM}
                                placeholder={getSelectPlaceholder(STATUS)}
                                handleChange={(selectedOption) => {
                                  leaveFilterValidation.setFieldValue(
                                    "status",
                                    selectedOption.value
                                  );
                                }}
                                handleBlur={() => {
                                  leaveFilterValidation.setFieldTouched(
                                    "status",
                                    true
                                  );
                                }}
                                value={LEAVE_STATUS_ENUM.find(
                                  (option) =>
                                    option.value ===
                                    leaveFilterValidation.values.status
                                )}
                                touched={leaveFilterValidation.touched.status}
                                error={leaveFilterValidation.errors.status}
                              />
                            </Col>
                            <Col>
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Select date"
                                onBlur={leaveFilterValidation.handleBlur}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "d.m.y",
                                  mode: "range",
                                  onChange: function (
                                    selectedDates,
                                    dateStr,
                                    instance
                                  ) {
                                    leaveFilterValidation.setFieldValue(
                                      "startDate",
                                      dateFormatChange(selectedDates[0])
                                    );
                                    leaveFilterValidation.setFieldValue(
                                      "endDate",
                                      dateFormatChange(selectedDates[1])
                                    );
                                  },
                                }}
                              />
                            </Col>
                            <Col className="col-lg-auto d-flex gap-2 align-items-start">
                              <button
                                className="btn btn-primary btn-sm createTask d-flex align-items-center justify-content-center"
                                type="submit"
                                disabled={loading}
                                style={{ height: "32px", minWidth: "80px" }}
                              >
                                {!loading ? (
                                  "SEARCH"
                                ) : (
                                  <div className="d-inline-flex align-items-center">
                                    <Spinner size="sm" className="me-2" />
                                    Loading...
                                  </div>
                                )}
                              </button>

                              {(leaveFilterValidation.values.categoryLeave ||
                                leaveFilterValidation.values.status ||
                                leaveFilterValidation.values.startDate ||
                                leaveFilterValidation.values.endDate) && (
                                <button
                                  type="button"
                                  className="btn btn-soft-danger btn-sm d-flex align-items-center justify-content-center"
                                  style={{ height: "32px", minWidth: "100px" }}
                                  onClick={() => {
                                    leaveFilterValidation.resetForm();

                                    const datePicker = document.getElementById(
                                      "datepicker-publish-input"
                                    );
                                    if (datePicker && datePicker._flatpickr) {
                                      datePicker._flatpickr.clear();
                                    }
                                    
                                    leaveFilterValidation.setFieldValue("startDate", null);
                                    leaveFilterValidation.setFieldValue("endDate", null);
                                    filterOfLeaveDetails({ userId: id })
                                      .then((response) =>
                                        setlistOfLeaveData(response?.data?.data)
                                      )
                                      .catch((err) => {
                                        setLoading(false);
                                        return err;
                                      })
                                      .finally(() => {
                                        setLoading(false);
                                        setStateValue(false);
                                      });


                                  }}
                                >
                                  <i className="ri-close-line align-bottom me-1"></i>
                                  Clear Filters
                                </button>
                              )}
                            </Col>
                          </Row>
                          <Row>
                            {(listOfLeaveData?.length > 0 || tableLoader) ? (
                              <TableContainer
                                id="dataTableId"
                                columns={leaveColumns}
                                data={listOfLeaveData || []}
                                isAddUserList={false}
                                customPageSize={5}
                                tableLoader={tableLoader}
                                divClass="table-responsive table-card mb-1"
                                tableClass="text-center table-wrap"
                                theadClass="table-light text-muted"
                              />
                            ) : (
                              <NoResultsMessage />
                            )}
                          </Row>
                        </Form>
                      </div>
                    </CardBody>
                  </Card>
                </Row>
              </Col>
            </Row>

            <Card></Card>
          </Container>
      </div>

      <Modal
        id="createTask"
        isOpen={modalTodo}
        toggle={toggle}
        modalClassName="zoomIn"
        centered
        tabIndex="-1"
      >
        <ModalHeader toggle={toggle} className="p-3 bg-soft-success">
          {!!isEdit ? "Edit Leave" : "Add Leave"}
        </ModalHeader>
        <ModalBody>
          <Form
            id="creattask-form"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <BaseInput
              label={NAME}
              name="name"
              type="text"
              placeholder={getInputPlaceholder(NAME)}
              value={name}
              disabled
            />

            <Row className="g-4 mb-3">
              <Col lg={6}>
                <label className="form-label">From:</label>
                <Flatpickr
                  name="fromDate"
                  id="date-field"
                  className={`form-control ${
                    validation.errors.fromDate && "is-invalid"
                  }`}
                  placeholder="From date"
                  options={{
                    altInput: true,
                    altFormat: "F j, Y",
                    dateFormat: "Y-m-d",
                    onChange: (selectedDates, dateStr) => {
                      validation.setFieldValue("fromDate", dateStr);
                    },
                  }}
                  value={validation.values.fromDate}
                />
                {validation.errors.fromDate && (
                  <div className="invalid-feedback">
                    {validation.errors.fromDate}
                  </div>
                )}
              </Col>

              <Col lg={6}>
                <label className="form-label">To:</label>
                <Flatpickr
                  name="toDate"
                  id="date-field"
                  className={`form-control ${
                    validation.errors.toDate && "is-invalid"
                  }`}
                  placeholder="To date"
                  options={{
                    altInput: true,
                    altFormat: "F j, Y",
                    dateFormat: "Y-m-d",
                    onChange: (selectedDates, dateStr) => {
                      validation.setFieldValue("toDate", dateStr);
                    },
                  }}
                  value={validation.values.toDate}
                />
                {validation.errors.toDate && (
                  <div className="invalid-feedback">
                    {validation.errors.toDate}
                  </div>
                )}
              </Col>
            </Row>

            <BaseInput
              label={NUMBER_OF_DAYS}
              name="leaveDays"
              type="number"
              placeholder={getInputPlaceholder(NUMBER_OF_DAYS)}
              value={validation.values.leaveDays}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              error={validation.errors.leaveDays}
              touched={validation.touched.leaveDays}
              disabled={role === "Admin"}
            />

            <BaseInput
              label={REASON}
              name="reason"
              type="textarea"
              placeholder={getInputPlaceholder(REASON)}
              value={validation.values.reason}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              error={validation.errors.reason}
              touched={validation.touched.reason}
              disabled={role == ADMIN}
              rows={3}
            />

            <BaseSelect
              label={""}
              name="leaveType"
              options={LEAVE_TYPES}
              handleChange={(selectedOption) => {
                validation.setFieldValue("leaveType", selectedOption?.value);
              }}
              handleBlur={validation.handleBlur}
              value={leaveTypeOptions.find(
                (opt) => opt.value === validation.values.leaveType
              )}
              touched={validation.touched.leaveType}
              error={validation.errors.leaveType}
              isDisabled={role === "Admin"}
            />

            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-ghost-success"
                onClick={() => setModalTodo(false)}
              >
                <i className="ri-close-fill align-bottom"></i>{" "}
                {role === "Admin" ? "Reject" : "Cancel"}
              </button>
              <button type="submit" className="btn btn-primary" id="addNewTodo">
                {role === "Admin" ? "Approve" : "Submit"}
              </button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <LeaveModal
        isOpen={isLeaveModalOpen}
        onClose={() => {
          setIsLeaveModalOpen(false);
          setEditData(null);
        }}
        editData={editData}
      />

      <Modal
        id="createTask"
        isOpen={modalTodoReject}
        toggle={toggleReject}
        modalClassName="zoomIn"
        centered
        tabIndex="-1"
      >
        <ModalHeader toggle={toggleReject} className="p-3 bg-soft-success">
          {" "}
          {!!isEditReject ? "Edit Leave" : "Reject Leave"}{" "}
        </ModalHeader>
        <ModalBody>
          <div id="task-error-msg" className="alert alert-danger py-2"></div>
          <Form
            id="creattask-form"
            onSubmit={(e) => {
              e.preventDefault();
              validationReject.handleSubmit();
              return false;
            }}
          >
            <input type="hidden" id="taskid-input" className="form-control" />
            <div className="mb-3">
              <label htmlFor="task-title-input" className="form-label">
                {" "}
                Full Name :
              </label>
              <Input
                type="text"
                id="task-title-input"
                className="form-control"
                placeholder="Enter Your Name"
                name="name"
                disabled
                value={leaveRejectNameData.firstName}
              />
            </div>
            <Row className="g-4 mb-3">
              <Col lg={6}>
                <label htmlFor="task-duedate-input" className="form-label">
                  From :
                </label>
                <Flatpickr
                  name="fromDate"
                  id="date-field"
                  disabled={role === "Admin"}
                  className="form-control"
                  placeholder="From date"
                  options={{
                    altInput: true,
                    altFormat: "d M, Y",
                    dateFormat: "d M, Y",
                  }}
                  value={leaveRejectData.fromDate}
                />
              </Col>
              <Col lg={6}>
                <label htmlFor="task-duedate-input" className="form-label">
                  To :
                </label>
                <Flatpickr
                  name="toDate"
                  id="date-field"
                  disabled={role === "Admin"}
                  className="form-control"
                  placeholder="To date"
                  options={{
                    altInput: true,
                    altFormat: "d M, Y",
                    dateFormat: "d M, Y",
                  }}
                  value={leaveRejectData.toDate}
                />
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label htmlFor="task-title-input" className="form-label">
                    Number of Days :
                  </label>
                  <Input
                    type="text"
                    id="task-title-input"
                    className="form-control"
                    placeholder="Enter task title"
                    name="leaveDays"
                    disabled={role === "Admin"}
                    value={leaveRejectData.leaveDays}
                  />
                </div>
              </Col>
            </Row>
            <div className="mb-3">
              <label htmlFor="task-title-input" className="form-label">
                Reject Leave Reason :
              </label>
              <Input
                type="text"
                id="task-title-input"
                className="form-control"
                placeholder="Enter Reject Reason"
                name="reason"
                validate={{ required: { value: true } }}
                onChange={validationReject.handleChange}
                onBlur={validationReject.handleBlur}
                value={validationReject.values.reason || ""}
                invalid={
                  validationReject.touched.reason &&
                  validationReject.errors.reason
                    ? true
                    : false
                }
              />
              {validationReject.touched.reason &&
              validationReject.errors.reason ? (
                <FormFeedback type="invalid">
                  {validationReject.errors.reason}
                </FormFeedback>
              ) : null}
            </div>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-ghost-success"
                onClick={() => setModalTodoReject(false)}
              >
                <i className="ri-close-fill align-bottom"></i> {"Cancel"}
              </button>
              <button type="submit" className="btn btn-primary" id="addNewTodo">
                {"Submit"}
              </button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default HRLeaves;
